import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import {
  Grid, Paper, Avatar, Button, Typography, FilledInput
} from '@material-ui/core'

import LockIcon from '@material-ui/icons/Lock'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import { getAccountFromDomain, resetPassword } from '../redux/actions/auth'

import { Toast } from '../components/ui'
import { Toast as NotificationToast } from '../components/ui/tools'
import { EmailMask } from '../components/ui/tools/TextMasks'
import { ValidateEmail } from '../utils'

const version = process.env.REACT_APP_VERSION

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    height: '25rem',
    width: '25rem'
  },
  lockIcon: {
    fontSize: '3rem'
  },
  lockAvatar: {
    marginTop: '1rem',
    width: 'fit-content',
    height: 'auto',
    backgroundColor: '#3984f7',
    color: '#fff',
    padding: theme.spacing(1),
    borderRadius: '50px'
  },
  input: {
    width: '90%',
    marginTop: '1.5rem'
  },
  backBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    width: '100%',
    marginTop: '2.6rem'
  },
  submitBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    width: '90%',
    marginTop: '1rem'
  },
  helpText: {
    marginTop: '1rem',
    fontSize: '1rem',
    color: '#737373',
    textAlign: 'center',
    marginRight: '1rem',
    marginLeft: '1rem'
  },
  centeredForm: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  logo: {
    width: '60%',
    marginTop: '1rem'
  },
  loginContainer: {
    height: '95vh',
    width: '100vw'
  }
}))

const CustomInput = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#A4D164'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#A4D164'
      }
    }
  }
})(FilledInput)

const PasswordReset = props => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [emailAddress, setEmailAddress] = useState('')
  const [accountID, setAccountID] = useState('')

  useEffect(() => {
    (async () => {
      if (window.location.hostname) {
        let subdomain = window.location.hostname
        if (subdomain === 'localhost') {
          subdomain = 'console.learnsafe.com'
        }
        const responseInfo = await getAccountFromDomain(subdomain)
        if (responseInfo && responseInfo.accountID) {
          // set state to accountID
          setAccountID(responseInfo.accountID)
        } else {
          Toast(true, 'Error getting account settings. Check that the url in your browser window is correct and attempt to reload the page.')
        }
      }
    }
    )()
  }, [])

  const submitPasswordReset = () => {
    dispatch(resetPassword(emailAddress, accountID, fireSuccess, fireFailure))
  }

  const fireSuccess = () => {
    NotificationToast(false, 'If your email address is found in our records, an email will be sent with instructions to reset your password shortly.')
    setEmailAddress('')
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to complete password reset.')
  }

  return (
    <>
      <Grid container direction='row' className={classes.loginContainer} justify='center' alignItems='center'>
        <Grid item container direction='row' justify='center'>
          <Paper classes={{ root: classes.paperRoot }}>
            <Grid item container direction='row' justify='center'>
              <img src={require('../assets/images/logo2.png')} className={classes.logo} alt='LearnSafe Cloud' />
            </Grid>
            <Grid item container direction='row' justify='center'>
              <Avatar variant='rounded' className={classes.lockAvatar}>
                <LockIcon className={classes.lockIcon} />
              </Avatar>
            </Grid>

            <Grid item container direction='row' justify='center'>
              <Typography className={`${classes.helpText} unselectable`}>
                Please type in your associated email.
              </Typography>
            </Grid>

            <Grid item container direction='row' justify='center'>
              <CustomInput
                label='Email Address'
                required
                name='email'
                variant='outlined'
                // variant='filled'
                error={!ValidateEmail(emailAddress)}
                value={emailAddress}
                onChange={e => setEmailAddress(e.target.value)}
                className={classes.input}
                inputComponent={EmailMask}
              />
            </Grid>

            <Grid item container direction='row' justify='center'>
              <Button
                className={classes.submitBtn}
                onClick={(e) => { e.preventDefault(); submitPasswordReset() }}
                disabled={!ValidateEmail(emailAddress)}
              >
                Reset Password
              </Button>
            </Grid>

            <Grid item container direction='row' justify='center'>
              <Button
                className={classes.backBtn}
                onClick={(e) => { e.preventDefault(); props.history.push('/login') }}
              >
                Return To Login
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid item container direction='row' justify='flex-end'>
        <Typography style={{ marginRight: '2rem' }}>{version}</Typography>
      </Grid>
    </>
  )
}

export default withRouter(PasswordReset)
